<template>
	<div>
		<div id="left-corner">
			<span id="staytionIcon">
				<router-link to="/"> STAYTION </router-link>
			</span>
			<span id="tag-line"> The Lived Experience, Redefined </span>
		</div>
		<div class="careers">
			<p id="title"> Current Openings </p>
			<div v-for="opening in openings" :key="opening.id">
				<div>
					<div class="opening-row">
						<p class="role"> {{ opening.role }} </p>
						<a href="mailto:careers@findyourstaytion.com" class="apply-button"> Apply </a>
					</div>
					<div class="tags-row">
						<p> {{ opening.location.toUpperCase() }}</p>
						<p> {{ opening.tag.toUpperCase() }} </p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Careers",
	data: function (){
		return {
			openings: [{
					id: 1,
					role: "Android OS Engineer",
					location: "San Francisco",
					tag: "Engineering",
				},
				{
					id: 2,
					role: "iOS App Developer",
					location: "Remote",
					tag: "Engineering",
				},
				{
					id: 3,
					role: "Android App Developer",
					location: "Remote",
					tag: "Engineering",
				},
				{
					id: 4,
					role: "Embedded Systems Engineer",
					location: "San Francisco",
					tag: "Engineering",
				},
				{
					id: 5,
					role: "Full Stack Developer",
					location: "Remote",
					tag: "Engineering",
				}
			]
		}
	},
	created () {
		document.title = "Careers at Staytion | Staytion";
	}
}
</script>

<style scoped>

* {
	box-sizing: border-box;
	color:#fff;
	text-decoration: none;
	font-family: proxima-nova, sans-serif;
}

#title {
	font-weight: 500;
	text-align: center;
	margin-bottom: 1em;
}


.careers {
	position: absolute;
	top: 20%;
	left: 50%;
	transform: translateX(-50%);
}

.opening-row {
	margin: 20px 0 0 0;
	display: flex;
}

.tags-row {
	margin: 0;
	display: flex;
	padding-left: 5px;
}

.tags-row p {
	margin: 5px 15px 0 0;
	opacity: 0.6;
}

.apply-button {
	display: flex;
	align-items: center;
	padding: 0 10px 0 10px;
	border-radius: 5px;
	cursor: pointer;
	border: 2px solid #fff;
}

.role {
	width: 80%;
	margin: 0;
	padding: 5px;
}

#left-corner {
	position: absolute;
	font-weight: bold;
	display: grid;
}

#tag-line {
	opacity: 0.8;
}


@media only screen and (min-device-width : 750px) {
	#title {
		font-size: calc(24px + 0.7vw);
	}

	.apply-button {
		font-size: calc(14px + 0.5vw);
	}
	.careers {
		width: 50%;
	}

	.role {
		font-size: calc(14px + 0.6vw);
	}

	.tags-row {
		font-size: calc(10px + 0.4vw);
	}

	#left-corner {
		top: 10%;
		left: 70px;
	}

	#staytionIcon {
		/* letter-spacing: 3px; */
		font-size: 3vw;
	}

	#tag-line {
		margin-top: 10px;
		font-size: 1.42vw;
	}
}

@media only screen and (max-device-width : 750px) {
	#title {
		font-size: calc(24px + 0.6vw);
	}

	.careers {
		width: 80%;
	}

	.role {
		font-size: calc(14px + 0.6vw);
	}

	.tags-row {
		font-size: calc(10px + 0.4vw);
	}
	#left-corner {
		width: 100%;
		top: 36px;
		text-align: center;
		left: 50%;
		transform: translateX(-50%);
		/* top: 24px; */
		/* left: 24px; */
	}

	#staytionIcon {
		letter-spacing: 5px;
		font-size: calc(36px + 0.5vw);
	}

	#tag-line {
		margin-top: 4px;
		font-size: calc(16px + 0.5vw);
	}
}

</style>